module.exports = __webpack_public_path__ + "images/patterns/dark/StripeHorizontal.f332fc8687fb8b884318.svg";